import { themeColors } from '../theme/theme';

// Simple spinning shimmer using theme colors
export function Shimmer({ size = 56, thickness = 5, style = {} }) {
  const radius = (size - thickness) / 2;
  const circumference = 2 * Math.PI * radius;
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        minHeight: 220,
        ...style,
      }}
    >
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ display: 'block' }}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={themeColors.primaryColor + '22'}
          strokeWidth={thickness}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={themeColors.primaryColor}
          strokeWidth={thickness}
          strokeDasharray={circumference * 0.7}
          strokeDashoffset={circumference * 0.15}
          strokeLinecap="round"
          style={{
            transformOrigin: 'center',
            animation: 'spin 0.9s linear infinite',
          }}
        />
      </svg>
      <style>{`
        @keyframes spin {
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
